import Vue from 'vue'
import Utils from './Utils'
import Auth from './Auth'

export default {
  url: Auth.getUrl('email-group'),
  paginate (meta) {
    return Utils.paginate(this.url, meta)
  },
  get (id) {
    return Vue.http.get(this.url + '/' + id)
  },
  signupPagePreviewUrl (id) {
    return Auth.domain + '/email-group/' + id + '/signup-page'
  },
  names () {
    return Vue.http.get(this.url + '/names')
  },
  create (data) {
    return Vue.http.post(this.url, data)
  },
  update (data) {
    return Vue.http.put(this.url + '/' + data.id, data)
  },
  remove (id) {
    return Vue.http.delete(this.url + '/' + id)
  },
  inGroup (id, meta) {
    return Utils.paginate('email/emails-in-group/' + id, meta)
  },
  statuses () {
    return [{id: 1, name: 'Aktywna'}, {id: 2, name: 'Nie aktywna'}]
  },
  getBaseItem () {
    return {
      id: null,
      name: '',
      email_account_id: -1,
      public: true,
      status: 1,

      user_agree: false,
      user_agree_url: '',
      user_agree_label: '',
      user_agree_text: '',

      user_agree2: false,
      user_agree2_url: '',
      user_agree2_label: '',
      user_agree2_text: '',

      form_title: 'Zapisz się na newsletter',
      form_html_body: '',
      form_submit_btn: 'Zapisz się',
      confirm_email_body: '',
      success_msg: 'Zapisałeś się',
      success_signup_template_html: null,
      success_signup_template_text: null,
      confirm_page_template: null
    }
  },
  convertNulls (item) {
    const keys = [
      'confirm_email_body',
      'form_html_body',
      'form_submit_btn',
      'form_title',
      'user_agree2_label',
      'user_agree2_text',
      'user_agree2_url',
      'user_agree_label',
      'user_agree_text',
      'user_agree_url'
    ]
    return Utils.convertNulls(keys, item)
  }
}



// WEBPACK FOOTER //
// ./src/services/EmailGroups.js